import React from 'react';

// Cell style for consistent table appearance
const cellStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  padding: '4px 2px',
  fontSize: '14px'
};

// Define table columns
export const tableColumns = [
  {
    name: 'Template ID',
    selector: row => row.template_id,
    sortable: true,
    center: true,
    width: '150px',
    style: cellStyle,
  },
  {
    name: 'Image',
    selector: row => row.image,
    sortable: false,
    center: true,
    width: '100px',
    style: cellStyle,
    cell: row => (
      <div style={{ ...cellStyle, display: 'flex', justifyContent: 'center' }}>
        <img 
          src={row.image} 
          alt="Template" 
          style={{ 
            height: '50px', 
            width: '70px', 
            objectFit: 'cover', 
            borderRadius: '4px' 
          }} 
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/50x35/CCCCCC/666666?text=No+Image';
          }}
        />
      </div>
    )
  },
  {
    name: 'Title',
    selector: row => row.title,
    sortable: true,
    center: true,
    width: '180px',
    style: cellStyle,
    cell: row => (
      <div style={{ 
        ...cellStyle,
        color: '#5662F6', // Blue color for title
        fontWeight: '500',
        width: '100%',
        textAlign: 'center'
      }}>
        {row.title}
      </div>
    ),
  },
  {
    name: 'Blessing text',
    selector: row => row.blessing_text,
    sortable: true,
    center: true,
    width: '200px',
    style: cellStyle,
  },
  {
    name: 'Category',
    selector: row => row.category,
    sortable: true,
    center: true,
    width: '150px',
    style: cellStyle,
  },
  {
    name: 'Status',
    selector: row => row.status,
    sortable: true,
    center: true,
    id: 'status',
    width: '100px',
    style: cellStyle,
    cell: row => (
      <span className="d-inline-block"
        style={{
          minWidth: '70px',
          textAlign: 'center',
          borderRadius: '20px',
          padding: '4px 8px',
          backgroundColor: getStatusColor(row.status),
          color: '#FFFFFF',
          fontSize: '10px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        {row.status}
      </span>
    )
  },
  {
    name: 'Action',
    selector: row => row.action,
    sortable: false,
    center: true,
    width: '150px',
    id: 'action',
    style: cellStyle,
  }
];

// Helper function to get status color
const getStatusColor = (status) => {
  const colorMap = {
    'Active': '#00C853',
    'Archive': '#8B5CF6'
  };
  return colorMap[status] || '#FFC107';
};